module.exports = __webpack_public_path__ + "img/view_comfy.40ac98c2.svg";